import { observable, makeObservable } from "mobx";
import { getLabOrder } from "../../serviceCalls";

export default class LabDetailStore {
  loading;
  labOrder;
  correctedLabs;
  selectedValue;

  constructor() {
    makeObservable(this, {
      loading: observable,
      labOrder: observable,
      correctedLabs: observable,
      selectedValue: observable,
    });
  }

  // content://com.airstrip.one.admin/emr/LaboratoryOrder?siteid=-1&asmpid=0001&OrderId=1741715567&EventId=2844879389&HasCorrections=false

  fetchLabOrder(query) {
    this.loading = true;
    getLabOrder(query)
      .then((res) => {
        this.labOrder = res;
        this.selectedValue = this.labOrder.values[0];
      })
      .catch(console.error)
      .finally(() => (this.loading = false));
  }
}
